/**
 * 与后端 auto-create.qa-quickapp-link.enabled 一致：为 false 时隐藏「分渠道收入汇总」菜单并拦截路由。
 * 未写入 localStorage 时视为 true（兼容旧后端未下发字段）。
 */
export function readAutoCreateQaQuickappLinkEnabled() {
  try {
    const r = localStorage.getItem('autoCreateQaQuickappLinkEnabled')
    if (r === 'false') return false
    if (r === 'true') return true
  } catch (e) { /* ignore */ }
  return true
}

export function isQaChannelIncomeMenuEnabled() {
  return readAutoCreateQaQuickappLinkEnabled()
}
